import { BaseChainSymbol } from '../global';

export const createKeyringId = (baseChainSymbol: BaseChainSymbol, guid?: string): string => guid ? `${baseChainSymbol}-${guid}` : baseChainSymbol;
